import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    CreateScreening: {
        method: 'POST',
        url: `${BASE_PATH_API}/premiumapplicantscreening/createApplicantScreening`
    },
    ValidateAddress: {
        method: 'POST',
        url: `${BASE_PATH_API}/premiumapplicantscreening/validateAddress`
    },
    GetScreeningsByApplicationId: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreening/:applicationId/screenings`
    },
    GetScreeningDetailsByGuid: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreening/getApplicantScreening/:guid/details`
    },
    RequestManualCriminalScreening: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreening/manual/criminal/:guid`
    },
    EnableManualCriminalScreening: {
        method: 'PUT',
        url: `${BASE_PATH_API}/premiumapplicantscreening/manual/criminal/:guid`
    },
    GetScreeningByGuid: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreening/getApplicantScreening/:guid`
    },
    HasCreditRetriever: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/hasCreditRetriever`
    },
    GetHtmlForUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreening/getOnSiteHtml`
    },
    SaveCriteriaDecision: {
        method: 'POST',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/aiScreeningCriteriaDecision`
    },
    SaveCriteriaCustomization: {
        method: 'POST',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/aiScreeningCriteriaCustomization`
    },
    SaveCredentialingApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/aiScreeningCredentialingApplication`
    },
    getAiScreeningAccountStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/aiScreeningAccountStatus`
    },
    SubmitSettingsUpdateRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/aiScreeningSettingsUpdateRequest`
    },
    getAiTenantScreeningSettingsData: {
        method: 'GET',
        url: `${BASE_PATH_API}/premiumapplicantscreeningaccountsettings/aiTenantScreeningSettingsData`
    },
};

export function PremiumApplicantScreeningApi() {
    return createActions(actions);
}
